module.exports = __webpack_public_path__ + "b8781f9b35f0bb1af9d5a78545e3aee3.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular-Oblique.woff
// module id = 402
// module chunks = 0